import React, { Component } from 'react';

import '../../styles/bootstrap.min.css'
import '../../styles/animate.min.css';
import '../../styles/font-awesome-4.7.0/css/font-awesome.min.css';
import '../../styles/main.css';
import '../../styles/gallery-grid.css';
import '../../styles/baguette-box.css';
import '../../styles/presets/preset1.css';
import '../../styles/responsive.css';

import WhatsAppIcon from '../../images/icon_whatsapp.png'
import WhatsAppCallIcon from '../../images/icon_whatsapp_call.png'

import Logo from '../../images/logo.png'
import LogoSM from '../../images/logo_sm.png'
import LogoMDA from '../../images/logo_mda.png'
import LogoSano from '../../images/logo-sano.png'

import IconMap from '../../images/icon-map.png'
import IconPhone from '../../images/icon-phone.png'
import IconEmail from '../../images/icon-email.png'
import IconLink from '../../images/icon-link.png'

import ImgCircuito from '../../images/img-circuito.png'

import Button from 'react-bootstrap/Button'
import Carousel from 'react-bootstrap/Carousel';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Card from 'react-bootstrap/Card'
import CardDeck from 'react-bootstrap/CardDeck'
import ListGroup from 'react-bootstrap/ListGroup'
import Form from 'react-bootstrap/Form'

import ModalImage from "react-modal-image";

import { addContact } from '../../api';

import {
  isBrowser,
  isTablet,
  isMobileOnly
} from "react-device-detect";

import ReactGA from 'react-ga4';
ReactGA.initialize('G-BSCBLKE66G');
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {

  constructor() {
    super();
    this.state = {
      collapsed: false,
      contactName: '',
      contactEmail: '',
      contactSubject: '',
      contactMessage: '',
      message: '',
      contactSubmitted: false,
      contactSent: false
    };
  }

  validateEmail(email) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email);
  }

  valid(payload) {
    try {
      return payload.name.length > 0 && this.validateEmail(payload.email) && payload.subject.length > 0 && payload.message.length > 0;
    } catch (e) {
      return false;
    }
  }

  handleNavBarClick(e) {
    if (isMobileOnly) {
      this.setState((state, props) => {
        return { collapsed: !state.collapsed };
      });
    }
  };

  handleChange = (e) => {
    let id = e.target.id;
    let touched = e.target.id + "Touched";
    this.setState({ [id]: e.target.value, [touched]: true });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    let payload = {
      name: this.state.contactName,
      email: this.state.contactEmail,
      subject: this.state.contactSubject,
      message: this.state.contactMessage
    };

    this.setState({ contactSubmitted: true });

    if (this.valid(payload)) {
      let self = this;
      addContact(payload).then(function (response) {
        if (response.status === 200) {
          self.setState({ message: "Mensagem enviada com sucesso.", contactSent: true })
        } else {
          self.setState({ message: response.data.message, contactSent: false })
        }
      })
        .catch(function (error) {
          self.setState({ message: "Ocorreu um erro ao enviar a mensagem.", contactSent: false })
        });
    }

    ReactGA.event('send_contact_msg');
  };

  render() {

    let cauroselItemStyle = {
      height: ''
    };

    if (isMobileOnly) {
      cauroselItemStyle.height = '568px';
    } else if (isTablet) {
      cauroselItemStyle.height = '1024px';
    } else if (isBrowser) {
      cauroselItemStyle.height = '934px';
    }

    return (
      <div>

        <div className="regus-overlay">
          <div className="regus-popup">
            <h3>Hub4work agora é HQ Americana, Figueiras!</h3>
            <a href="https://www.regus.com/pt">
              www.regus.com/pt
            </a>
          </div>
        </div>

        <div className="whatsapp">
          <div className="call-whatsapp">
            <a href="https://api.whatsapp.com/send?l=pt_BR&phone=55019998108949" target="_blank" rel="noopener noreferrer">
              <img src={WhatsAppCallIcon} alt="" />
            </a>
          </div>
          <div className="icon-whatsapp">
            <a href="https://api.whatsapp.com/send?l=pt_BR&phone=55019998108949" target="_blank" rel="noopener noreferrer">
              <img src={WhatsAppIcon} alt="" />
            </a>
          </div>
        </div>

        <header id="home">
          <Navbar onToggle={(e) => { }} expanded={this.state.collapsed} fixed="top" bg="light" expand="lg" className="main-nav menu-fixo">
            <Container>
              <Navbar.Brand href="#home">
                <h1 className="logo-md"><img className="img-fluid logo" src={Logo} alt="logo" /></h1>
                <h1 className="logo-sm"><img className="img-fluid logo" src={LogoSM} alt="logo" /></h1>
              </Navbar.Brand>
              <Navbar.Toggle onClick={(e) => this.handleNavBarClick(e)} className="border-zero" aria-controls="basic-navbar-nav">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </Navbar.Toggle>
              <Navbar.Collapse id="basic-navbar-nav">
                <ul className="nav navbar-nav ml-auto mr-auto">
                  <li className="scroll"><a href="#home" onClick={(e) => this.handleNavBarClick(e)}>Home</a></li>
                  <li className="scroll"><a href="#coworking" onClick={(e) => this.handleNavBarClick(e)}>Coworking</a></li>
                  <li className="scroll"><a href="#structure" onClick={(e) => this.handleNavBarClick(e)}>Estrutura</a></li>
                  <li className="scroll"><a href="#salas" onClick={(e) => this.handleNavBarClick(e)}>Produtos</a></li>
                  <li className="scroll"><a href="#plans" onClick={(e) => this.handleNavBarClick(e)}>Planos</a></li>
                  <li className="scroll"><a href="#location" onClick={(e) => this.handleNavBarClick(e)}>Localização</a></li>
                  <li className="scroll"><a href="#contact" onClick={(e) => this.handleNavBarClick(e)}>Contato</a></li>
                  <li className="scroll"><a href="https://www.linkedin.com/company/hub4work"
                    onClick={(e) => this.handleNavBarClick(e)}
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fa fa-linkedin font-size-20" aria-hidden="true"></i>
                  </a></li>
                  <li className="scroll"><a href="https://api.whatsapp.com/send?l=pt_BR&phone=55019998108949"
                    onClick={(e) => this.handleNavBarClick(e)}
                    className="whats"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fa fa-whatsapp font-size-20" aria-hidden="true"></i>
                  </a></li>
                </ul>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          <Carousel id="home-slider" className="carousel slide carousel-fade" data-ride="carousel" data-interval="5500">
            <Carousel.Item className="item slider-1" style={cauroselItemStyle}>
              <Carousel.Caption className="caption">
                <h1 className="animated fadeInRightBig t-slider">O ESPAÇO IDEAL <br /> PARA O SEU <span>NEGÓCIO</span></h1>
                <p className="animated fadeInLeftBig">
                  Soluções simples, flexíveis e prontas para uso.
                </p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="item slider-2" style={cauroselItemStyle}>
              <Carousel.Caption className="caption">
                <h1 className="animated fadeInRightBig t-slider">ESPAÇO PROJETADO <br /> PARA <span>VOCÊ</span></h1>
                <p className="animated fadeInLeftBig">
                  Venha trabalhar em um ambiente único e criativo.
                </p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="item slider-3" style={cauroselItemStyle}>
              <Carousel.Caption className="caption">
                <h1 className="animated fadeInRightBig t-slider">TRABALHE <br />COM <span>TRANQUILIDADE</span></h1>
                <p className="animated fadeInLeftBig">
                  Muito mais economia que no aluguel convencional.
                </p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>


        </header>
        <section id="coworking" className="padding-bottom-zero">
          <div className="container">
            <div className="row">
              <div className="col-md-7 col-sm-12">
                <div className="coworking-info wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                  <br /><br />
                  <div className="barra-titulo"></div>
                  <h2 className="txt-left">COWORKING <img src={ImgCircuito} alt="Coworking" /></h2>
                  <br />
                  <p className="txt-justificado">
                    É um espaço de trabalho onde pessoas, profissionais e empresas dividem o mesmo local em busca de economia, estrutura planejada e ambiente agradável.
                  </p>
                  <br />
                  <p className="txt-justificado">
                    Empreendedores e profissionais de diversos segmentos da economia podem iniciar seus negócios, trabalhar, atender clientes, realizar reuniões, ministrar palestras e treinamentos, além de aumentar o networking com pessoas de diferentes áreas.
                  </p>
                  <br />
                  <p className="txt-justificado">
                    Estamos presentes na cidade de Americana oferecendo espaços compartilhados para trabalho, sala de reunião, salas de trabalho privativas, espaço para cursos e treinamentos, serviços de escritório virtual e secretariado.
                  </p>
                  <br />
                  <p className="txt-justificado">
                    Venha conhecer hoje mesmo, estamos esperando por você.
                  </p>
                  <br />
                  <p className="coworking-slogan color-blue">PARA PESSOAS COMO VOCÊ</p>
                  <p className="coworking-slogan color-orange">EMPREENDEDOR</p>
                </div>
              </div>
              <div className="col-md-5 col-sm-12">
                <img src={'https://storage.googleapis.com/hub4work/person.jpg'} className="img-fluid" alt="Pessoa no Trabalho" />
              </div>
            </div>
          </div>
        </section>
        <section id="hub4work" className="parallax">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-1 col-sm-12">
                <div className="servicos-info wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                  <br />
                  <p className="txt-center font-size-30">
                    Na <span className="color-orange">Hub4Work</span>, toda a estrutura está disponível sem necessidade de contrato de fidelidade. Com um simples cadastro você ou a sua empresa já podem usar os espaços e os serviços. Você paga apenas por aquilo que utiliza.
                  </p>
                  <br />
                </div>
                <div className="logo-mda">
                  <img src={LogoMDA} alt="Hub for Work" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="structure" className="padding-bottom-zero">
          <div className="container">
            <div className="row">
              <div className="heading col-md-12 wow fadeInUp" data-wow-duration="1200ms" data-wow-delay="300ms">
                <br /><br />
                <div className="barra-titulo"></div>
                <h2 className="txt-left">ESTRUTRA <img src={ImgCircuito} alt="Estrutura" /></h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-wifi font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">INTERNET DE <br /> ALTA VELOCIDADE</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-phone font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">ATENDIMENTO <br /> TELEFÔNICO</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-cutlery font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">COZINHA E <br /> COPA</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-comments font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">ESPAÇO DE <br />CONVIVÊNCIA</h6>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-clock-o font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">SEGURANÇA <br /> 24 HORAS</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-thermometer-empty font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">AMBIENTE <br /> CLIMATIZADO</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-print font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">IMPRESSÃO</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-female font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">RECEPÇÃO</h6>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-envelope font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">CORRESPONDÊNCIA</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-tasks font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">LOCKERS</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-calendar-check-o font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">SALA DE <br /> REUNIÃO</h6>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="icon-services txt-center">
                  <i className="fa fa-coffee font-size-50 color-blue" aria-hidden="true"></i>
                  <h6 className="negrito">CAFÉ</h6>
                </div>
              </div>
            </div>

          </div>
        </section>
        <section id="salas" className="padding-bottom-zero">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="coworking-info wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                  <div className="heading wow fadeInUp" data-wow-duration="1200ms" data-wow-delay="300ms">
                    <br /><br />
                    <div className="barra-titulo"></div>
                    <h2 className="txt-left">PRODUTOS <img src={ImgCircuito} alt="Produtos" /></h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="features" className="parallax">
          <div className="container">
            <div className="features-info">
              <br />
              <h2 className="animated fadeInRightBig text-right slogan-americana">O COWORKING DOS EMPREENDEDORES <br /> DE <span className="coworking-slogan color-orange">AMERICANA</span> E REGIÃO</h2>
              <div className="logo-mda">
                <img src={LogoMDA} alt="Hub for Work" />
              </div>
            </div>
          </div>
        </section>
        <section id="features2" className="padding-bottom-zero">
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <br /><br />
                <p className="text-justify">
                  As <b>salas compartilhadas</b> são compostas por estações de trabalho individuais, que você poderá utilizar por hora, por dia ou no plano mensal. </p><br />
                <p className="text-justify">
                  Nas <b>salas privativas</b>, além de toda a infraestrutura oferecida nas salas compartilhadas, você dispõem de um espaço exclusivo e reservado sem abrir mão da energia e dinamismo do coworking.</p><br />
                <p className="text-justify">
                  Para os compromissos privativos como reuniões, atendimentos, cursos, treinamentos e aulas, temos <b>sala de reunião</b>.</p><br />
                <p className="text-justify">
                  Além dos espaços físicos, temos o plano de <b>escritório virtual</b> que inclui o serviço de administração de correspondência e endereço comercial.</p><br />

              </div>
              <div className="col-md-7">
                <br />
                <div className="tz-gallery">

                  <div className="row">
                    <div className="col-6 col-md-4" style={{ marginBottom: '18px' }}>
                      <ModalImage hideDownload={true} hideZoom={true}
                        small={'https://storage.googleapis.com/hub4work/produto1_sm.jpg'}
                        large={'https://storage.googleapis.com/hub4work/produto1.jpg'}
                        alt="Espaço Compartilhado"
                      />
                    </div>
                    <div className="col-6 col-md-4" style={{ marginBottom: '18px' }}>
                      <ModalImage hideDownload={true} hideZoom={true}
                        small={'https://storage.googleapis.com/hub4work/produto2_sm.jpg'}
                        large={'https://storage.googleapis.com/hub4work/produto2.jpg'}
                        alt="Salas Privadas"
                      />
                    </div>
                    <div className="col-6 col-md-4" style={{ marginBottom: '18px' }}>
                      <ModalImage hideDownload={true} hideZoom={true}
                        small={'https://storage.googleapis.com/hub4work/produto3_sm.jpg'}
                        large={'https://storage.googleapis.com/hub4work/produto3.jpg'}
                        alt="Sala Privada"
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <ModalImage hideDownload={true} hideZoom={true}
                        small={'https://storage.googleapis.com/hub4work/produto4_sm.jpg'}
                        large={'https://storage.googleapis.com/hub4work/produto4.jpg'}
                        alt="Sala de Reunião"
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <ModalImage hideDownload={true} hideZoom={true}
                        small={'https://storage.googleapis.com/hub4work/produto5_sm.jpg'}
                        large={'https://storage.googleapis.com/hub4work/produto5.jpg'}
                        alt="Deck"
                      />
                    </div>
                    <div className="col-6 col-md-4">
                      <ModalImage hideDownload={true} hideZoom={true}
                        small={'https://storage.googleapis.com/hub4work/produto6_sm.jpg'}
                        large={'https://storage.googleapis.com/hub4work/produto6.jpg'}
                        alt="Espaço Compartilhado"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="plans" className="padding-bottom-zero">
          <div className="container">
            <div className="row">
              <br /><br />
              <div className="heading col-md-12 wow fadeInUp" data-wow-duration="1200ms" data-wow-delay="300ms">
                <div className="barra-titulo"></div>
                <h2 className="txt-left">PLANOS <img src={ImgCircuito} alt="Planos" /></h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <p className="text-justify">
                  Você poderá aderir a um de nossos planos que mais se ajuste às suas necessidades. Confira abaixo nossos valores e escolha o plano com o melhor custo/benefício para seu negócio. Todos os planos da Hub4Work incluem internet de alta velocidade, ambiente climatizado, área de convivência, copa / cozinha, café, água e chá.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <CardDeck>
                  <Card className="mt-4 mx-auto" style={{ borderColor: '#003399', minWidth: '260px', maxWidth: '260px' }}>
                    <Card.Img variant="top" src="https://storage.googleapis.com/hub4work/price1.jpg" />
                    <Card.Body className="color-blue">
                      <Card.Title>HORA AVULSA</Card.Title>
                      <ListGroup variant="flush">
                        <ListGroup.Item>Estação de Trabalho Flexível</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                    <Card.Footer style={{ borderColor: 'rgba(0, 0, 0, 0.125)' }}>
                      <div className="valor_1">R$ 15,</div><div className="valor_2">00</div>
                    </Card.Footer>
                  </Card>

                  <Card className="mt-4 mx-auto" style={{ borderColor: '#003399', minWidth: '260px', maxWidth: '260px' }}>
                    <Card.Img variant="top" src="https://storage.googleapis.com/hub4work/price2.jpg" />
                    <Card.Body className="color-blue">
                      <Card.Title>40 HORAS</Card.Title>
                      <ListGroup variant="flush">
                        <ListGroup.Item>Estação de Trabalho Flexível</ListGroup.Item>
                        <ListGroup.Item>1h Sala de Reunião Mês</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                    <Card.Footer style={{ borderColor: 'rgba(0, 0, 0, 0.125)' }}>
                      <div className="valor_1">R$ 235,</div><div className="valor_2">00</div>
                    </Card.Footer>
                  </Card>

                  <Card className="mt-4 mx-auto" style={{ borderColor: '#003399', minWidth: '260px', maxWidth: '260px' }}>
                    <Card.Img variant="top" src="https://storage.googleapis.com/hub4work/price3.jpg" />
                    <Card.Body className="color-blue">
                      <Card.Title>MENSAL</Card.Title>
                      <ListGroup variant="flush">
                        <ListGroup.Item>Estação de Trabalho Dedicada</ListGroup.Item>
                        <ListGroup.Item>3hs Sala de Reunião Mês</ListGroup.Item>
                        <ListGroup.Item>Recepção de Clientes</ListGroup.Item>
                        <ListGroup.Item>Administração de Correspondência</ListGroup.Item>
                        <ListGroup.Item>Locker</ListGroup.Item>
                        <ListGroup.Item>Impressão, scanner e cópias</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                    <Card.Footer style={{ borderColor: 'rgba(0, 0, 0, 0.125)' }}>
                      <div className="valor_1">R$ 640,</div><div className="valor_2">00</div>
                    </Card.Footer>
                  </Card>

                  <Card className="mt-4 mx-auto" style={{ borderColor: '#003399', minWidth: '260px', maxWidth: '260px' }}>
                    <Card.Img variant="top" src="https://storage.googleapis.com/hub4work/price4.jpg" />
                    <Card.Body className="color-blue">
                      <Card.Title>SALA PRIVATIVA</Card.Title>
                      <ListGroup variant="flush">
                        <ListGroup.Item>Sala Exclusiva</ListGroup.Item>
                        <ListGroup.Item>5hs Sala de Reunião Mês</ListGroup.Item>
                        <ListGroup.Item>Recepção de Clientes</ListGroup.Item>
                        <ListGroup.Item>Administração de Correspondência</ListGroup.Item>
                        <ListGroup.Item>Impressão, scanner e cópias</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                    <Card.Footer style={{ borderColor: 'rgba(0, 0, 0, 0.125)' }}>
                      <div className="valor_1">R$ 1100,</div><div className="valor_2">00</div>
                    </Card.Footer>
                  </Card>

                  <Card className="mt-4 mx-auto" style={{ borderColor: '#003399', minWidth: '260px', maxWidth: '260px' }}>
                    <Card.Img variant="top" src="https://storage.googleapis.com/hub4work/price5.jpg" />
                    <Card.Body className="color-blue">
                      <Card.Title>SALA DE REUNIÃO</Card.Title>
                      <ListGroup variant="flush">
                        <ListGroup.Item>Espaço com 6 Posições</ListGroup.Item>
                        <ListGroup.Item>TV para Projeção</ListGroup.Item>
                        <ListGroup.Item>Lousa</ListGroup.Item>
                        <ListGroup.Item>Café, Água e Chá</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                    <Card.Footer style={{ borderColor: 'rgba(0, 0, 0, 0.125)' }}>
                      <div className="valor_1">R$ 40,</div><div className="valor_2">00</div>
                    </Card.Footer>
                  </Card>

                  <Card className="mt-4 mx-auto" style={{ borderColor: '#003399', minWidth: '260px', maxWidth: '260px' }}>
                    <Card.Img variant="top" src="https://storage.googleapis.com/hub4work/price6.jpg" />
                    <Card.Body className="color-blue">
                      <Card.Title>ESCRITÓRIO VIRTUAL</Card.Title>
                      <ListGroup variant="flush">
                        <ListGroup.Item>Endereço Comercial</ListGroup.Item>
                        <ListGroup.Item>Administração de Correspondência</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                    <Card.Footer style={{ borderColor: 'rgba(0, 0, 0, 0.125)' }}>
                      <div className="valor_1">R$ 150,</div><div className="valor_2">00</div>
                    </Card.Footer>
                  </Card>
                </CardDeck>

              </div>
            </div>
          </div>
        </section>
        <section id="location" className="padding-bottom-zero">
          <div className="container">
            <div className="row">
              <br /><br />
              <div className="heading col-md-12 wow fadeInUp" data-wow-duration="1200ms" data-wow-delay="300ms">
                <div className="barra-titulo"></div>
                <h2 className="txt-left">LOCALIZAÇÃO <img src={ImgCircuito} alt="Localização" /></h2>
              </div>
            </div>
            <div className="row">
              <div className="wow fadeInUp text-center" data-wow-duration="1200ms" data-wow-delay="300ms">
                <button className="btn btn-primary" type="button" id="btn_map_1">
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  &nbsp;Endereço
                </button>
                {/*
                                <button className="btn btn-primary" type="button" id="btn_map_2">
                                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                                    Endereço 2
                                </button>
                                */}
              </div>
            </div>
          </div>
        </section>

        <div id="map_1">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1839.668371443607!2d-47.33866780881695!3d-22.752881089224662!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c8997deb5be37f%3A0x6fd2d51c5dd9adf4!2sR.+das+Figueiras%2C+251+-+Jardim+Sao+Paulo%2C+Americana+-+SP%2C+13468-160!5e0!3m2!1sen!2sbr!4v1549224527815" width="100%" height="450" frameBorder="0" className="border-zero" allowFullScreen title="Mapa 1"></iframe>
        </div>
        {/*
                <div id="map_2">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.8136073728456!2d-47.343798884975385!3d-22.735168337485465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c89bc7c12bca75%3A0xacef3a0c4a21af2f!2sAv.+Rafael+Vitta%2C+Americana+-+SP!5e0!3m2!1spt-BR!2sbr!4v1535134595959" width="100%" height="450" frameBorder="0" className="border-zero" allowFullScreen title="Mapa 2"></iframe>
                </div>
                 */}
        <section id="contact" className="padding-bottom-zero">
          <div id="contact-us" className="parallax">
            <div className="container">
              <div className="row">
                <div className="heading col-md-12 wow fadeInUp" data-wow-duration="1200ms" data-wow-delay="300ms">
                  <div className="barra-titulo"></div>
                  <h2 className="txt-left color-blue">CONTATO <img src={ImgCircuito} alt="Contato" /></h2>
                  <p>Entre em contato e envie a sua mensagem que responderei o mais breve possível.</p>
                </div>
              </div>
              <div className="contact-form wow fadeIn" data-wow-duration="1000ms" data-wow-delay="600ms">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <Form noValidate validated={this.validated} onSubmit={(event) => this.handleSubmit(event)}>
                      <div className="wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                        <Form.Row>
                          <Form.Group controlId="contactName" className="col-sm-6">
                            <Form.Control
                              as="input"
                              required
                              type="text"
                              placeholder="Nome"
                              defaultValue={this.state.contactName}
                              onChange={(event) => this.handleChange(event)}
                              isInvalid={this.state.contactSubmitted && this.state.contactName.length === 0}
                              disabled={this.state.contactSent}
                              name="contactName"
                            />
                          </Form.Group>
                          <Form.Group controlId="contactEmail" className="col-sm-6">
                            <Form.Control
                              as="input"
                              required
                              type="text"
                              placeholder="E-mail"
                              defaultValue={this.state.contactEmail}
                              onChange={(event) => this.handleChange(event)}
                              isInvalid={this.state.contactSubmitted && !this.validateEmail(this.state.contactEmail)}
                              disabled={this.state.contactSent}
                              name="contactEmail"
                            />
                          </Form.Group>
                        </Form.Row>
                        <Form.Row>
                          <Form.Group controlId="contactSubject" className="col-sm-12">
                            <Form.Control
                              as="input"
                              required
                              type="text"
                              placeholder="Assunto"
                              defaultValue={this.state.contactSubject}
                              onChange={(event) => this.handleChange(event)}
                              isInvalid={this.state.contactSubmitted && this.state.contactSubject.length === 0}
                              disabled={this.state.contactSent}
                              name="contactSubject"
                            />
                          </Form.Group>
                        </Form.Row>
                        <Form.Row>
                          <Form.Group controlId="contactMessage" className="col-sm-12">
                            <Form.Control
                              as="textarea"
                              rows="4"
                              required
                              type="text"
                              placeholder="Digite a sua mensagem"
                              defaultValue={this.state.contactMessage}
                              onChange={(event) => this.handleChange(event)}
                              isInvalid={this.state.contactSubmitted && this.state.contactMessage.length === 0}
                              disabled={this.state.contactSent}
                              name="contactMessage"
                            />
                          </Form.Group>
                        </Form.Row>
                        {this.state.contactSent ?
                          <p className="color-blue" style={{ height: '30px' }}>Mensagem enviada com Sucesso!</p>
                          : (this.state.message === '' ?
                            <Button type="submit" className="btn-submit">Enviar mensagem</Button>
                            :
                            <p className="color-red">{this.state.message}</p>
                          )
                        }
                      </div>
                    </Form>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="contact-info wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                      <ul className="address">
                        <li><i className="fa fa-map-marker font-size-15"></i><strong> Endereço:</strong>
                          <br />Rua das Figueiras, 251
                          <br />Jardim São Paulo - Americana, SP <br /><br /></li>
                        <li><i className="fa fa-phone font-size-15"></i><strong> Telefone:</strong>
                          <br />(19) 3406.1314 <br /><br /></li>
                        <li><i className="fa fa-clock-o font-size-15"></i><strong> Atendimento:</strong>
                          <br />Seg. à Sex. das 8h às 18h <br /><br /></li>
                        <li><i className="fa fa-globe font-size-15"></i><strong> Site:</strong>
                          <br /><a href="https://www.hub4work.com.br/#">www.hub4work.com.br</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="logo-mda">
                  <img src={LogoMDA} alt="Hub for Work" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer id="footer">
          <div className="footer-top"></div>
          <div className="footer-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <div className="icon-map">
                    <div className="footer-icon address">
                      <img src={IconMap} alt="Endereço" />
                    </div>
                    <div className="color-black">
                      Rua das Figueiras, 251 <br />
                      Jardim São Paulo <br />
                      Americana, SP CEP 13468-160
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="icon-phone">
                    <div className="footer-icon address">
                      <img src={IconPhone} alt="Telefone" />
                    </div>
                    <div className="color-black">
                      <span className="font-size-10">19</span> <span className="font-size-12">3406.1314</span> <br />
                      <span className="font-size-10">19</span> <span className="font-size-12">99810.8949</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="icon-email">
                    <div className="footer-icon">
                      <img src={IconEmail} alt="Email" />
                    </div>
                    <div className="color-black font-size-12">
                      <img src={IconLink} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="logo-sano">
                  <a href="http://www.sanoweb.com.br" target="_blank" rel="noopener noreferrer">
                    <span>criado por: </span><img src={LogoSano} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom"></div>
        </footer>
      </div>
    );
  }
}

export default App;
